import { render, staticRenderFns } from "./ScoresWelcomeToTheMoon.vue?vue&type=template&id=1a9ef33c"
import script from "./ScoresWelcomeToTheMoon.vue?vue&type=script&lang=ts"
export * from "./ScoresWelcomeToTheMoon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports